// extracted by mini-css-extract-plugin
export default {"content":"cR_content__1lpKB","content_text":"cR_content_text__PfG6M","m":"cR_m__ZZ8HL","content_image":"cR_content_image__c84Yi","p":"cR_p__C3zrG"};